import type { ApiBody } from '../../../shared/api/contracts'
import { apiGet, apiPost, apiPut, apiDelete } from './transport'

export async function fetchNotificationSettings(signal?: AbortSignal) {
  return apiGet<'GET /admin/notifications/settings'>('/admin/notifications/settings', signal)
}

export async function updateNotificationSettings(payload: ApiBody<'PUT /admin/notifications/settings'>, signal?: AbortSignal) {
  return apiPut<'PUT /admin/notifications/settings'>('/admin/notifications/settings', payload, signal)
}

export async function createNotificationRule(payload: ApiBody<'POST /admin/notifications/rules'>, signal?: AbortSignal) {
  return apiPost<'POST /admin/notifications/rules'>('/admin/notifications/rules', payload, signal)
}

export async function updateNotificationRule(id: string, payload: ApiBody<'PUT /admin/notifications/rules/:id'>, signal?: AbortSignal) {
  return apiPut<'PUT /admin/notifications/rules/:id'>(`/admin/notifications/rules/${encodeURIComponent(id)}`, payload, signal)
}

export async function deleteNotificationRule(id: string, signal?: AbortSignal) {
  return apiDelete<'DELETE /admin/notifications/rules/:id'>(`/admin/notifications/rules/${encodeURIComponent(id)}`, signal)
}

export async function sendTestNotification(message: string, signal?: AbortSignal) {
  return apiPost<'POST /admin/notifications/test'>('/admin/notifications/test', { message }, signal)
}
